export default "__VITE_ASSET__DhmY2uh6__"